import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['One level per plan — the mixed group is on you', 'Videos of the finished skill, few clues on how to get there', 'A monthly fee that never ends', 'Often built for advanced skaters, not your Tuesday group', 'You still decide what to run on Tuesday'];
const withIt = ['A ready-to-run lesson for every week of the season', 'Every skill in three versions: Beginner, Developing, Advanced', 'Warm-up games and group choreography included', 'One payment — no subscription', "Works alongside any federation's level system"];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-463" data-mp="2954ivjt7gomv">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-464" data-mp="2d7hlw0gki8fy">
        <div className="text-center" data-id="element-465" data-mp="30ymze8z1con3">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-amber-deep" data-id="element-466" data-mp="30xlhbkjlr1vv">
            Why this isn&apos;t another lesson plan
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold text-rink text-3xl sm:text-5xl" data-id="element-467" data-mp="1tetpsck1w9wx">
            Basic plans vs{' '}
            <span className="text-coral-deep" data-id="element-468" data-mp="1oeffenuz8nvq">a season on three lanes</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-469" data-mp="23796z7niwugr">
            Official plans tell you what to teach at each level. Video libraries
            show you what the finished skill looks like. Neither tells you how
            to run one group, with three levels, on one sheet of ice — every
            single week.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-card border border-ice-dark" data-id="element-470" data-mp="2h4xrgedohzla">
          <div className="bg-ice px-3.5 py-4 sm:p-6" data-id="element-471" data-mp="rpzrsxbfgol9">
            <h3 className="font-display text-base font-bold text-ink-soft sm:text-xl" data-id="element-472" data-mp="rqj7s8hip2wn">
              Free basic plans or a monthly video library
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-473" data-mp="2mtpbk8cqkt61">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-474" data-mp="2rrz6qiygntrn">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-475" data-mp="2vw6zqsbybvvo">
                    <XIcon className="h-2.5 w-2.5 text-coral-deep" aria-hidden="true" data-id="element-476" data-mp="35s9zjrjbzifg" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-rink px-3.5 py-4 text-white sm:p-6" data-id="element-477" data-mp="3fjxxmbae7xpw">
            <h3 className="font-display text-base font-bold text-amber sm:text-xl" data-id="element-478" data-mp="3ji5329zepcls">
              Figure Skating Class Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-479" data-mp="3ogopebhwwqeo">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-480" data-mp="3tfi76g48f3kn">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-amber/20" data-id="element-481" data-mp="2gapnte4ax8t">
                    <CheckIcon className="h-2.5 w-2.5 text-amber-hover" aria-hidden="true" data-id="element-482" data-mp="3tnn2xxbvqqjg" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}